import { createApiV2 } from "./common";

export const getLabels = () => (token) =>
  createApiV2("GET", "collaborate/labels/")(token);

export const createLabel = (data) => (token) =>
  createApiV2("POST", "collaborate/labels/")(token, data);

export const updateLabel = (labelUid, data) => (token) =>
  createApiV2("PUT", `collaborate/labels/${labelUid}/`)(token, data);

export const deleteLabel = (labelUid) => (token) =>
  createApiV2("DELETE", `collaborate/labels/${labelUid}/`)(token);

export const postLabelToMessage = (messageId, labelUid) => (token) =>
  createApiV2("POST", "collaborate/label-attachments/attach/")(token, {
    message_id: messageId,
    label_uid: labelUid,
  });

export const postLabelToFile = (messageId, labelUid, fileId) => (token) =>
  createApiV2("POST", "collaborate/label-attachments/attach/")(token, {
    message_id: messageId,
    label_uid: labelUid,
    file_id: fileId,
  });

export const deleteLabelFromMessage = (attachmentId) => (token) =>
  createApiV2("DELETE", "collaborate/label-attachments/detach/")(token, {
    attachment_id: attachmentId,
  });
